import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS_STEPS } from "../data/content";

export const Process = () => (
  <section id="process" data-testid="process-section" className="noise-overlay relative bg-navy-900 py-24 lg:py-32">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.05),transparent_50%)]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <SectionHeading
        overline="How It Works"
        testId="process-heading"
        title={
          <>
            Three steps. <span className="text-gold-metallic italic">Zero friction.</span>
          </>
        }
      />

      <div className="relative mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
        <div aria-hidden="true" className="absolute left-0 right-0 top-10 hidden border-t border-dashed border-gold/20 md:block" />
        {PROCESS_STEPS.map((step, i) => (
          <Reveal key={step.number} delay={i * 0.14}>
            <div data-testid={`process-step-${i + 1}`} className="group relative">
              <div className="relative z-10 mb-7 flex h-20 w-20 items-center justify-center rounded-full border border-gold/30 bg-navy-950 font-display text-2xl font-bold text-gold-metallic transition-all duration-500 group-hover:shadow-[0_0_36px_rgba(212,175,55,0.3)]">
                {step.number}
              </div>
              <h3 className="font-display text-2xl sm:text-3xl font-semibold text-slate-50">{step.title}</h3>
              <p className="mt-3 max-w-sm text-sm sm:text-base leading-relaxed text-slate-400">{step.text}</p>
              {i < PROCESS_STEPS.length - 1 && (
                <ArrowRight className="mt-5 h-5 w-5 text-gold/40 md:absolute md:-right-4 md:top-8 md:mt-0" />
              )}
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <a
          href="#contact"
          data-testid="process-cta"
          className="btn-gold mt-14 inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-navy-950 transition-[box-shadow,transform] duration-400 hover:-translate-y-1 hover:shadow-[0_18px_50px_-10px_rgba(212,175,55,0.55)]"
        >
          Start Step One — It's Free
          <ArrowRight className="h-4 w-4" />
        </a>
      </Reveal>
    </div>
  </section>
);
